export const addNbsp = (str: string) => {
  const index = str.trim().lastIndexOf(' ');
  if (index) {
    return str.substring(0, index) + '\u00A0' + str.substring(index + 1);
  }
  return str;
};
